import React, { useState } from 'react';
import { FaCheckCircle, FaTimesCircle, FaEye } from 'react-icons/fa';

interface VerificationRequest {
  id: number;
  name: string;
  email: string;
  documentUrl: string;
  status: 'Pending' | 'Accepted' | 'Rejected';
}

const initialRequests: VerificationRequest[] = [
  { id: 1, name: 'Alice Johnson', email: 'alice@example.com', documentUrl: 'https://example.com/doc1.pdf', status: 'Pending' },
  { id: 2, name: 'Bob Smith', email: 'bob@example.com', documentUrl: 'https://example.com/doc2.pdf', status: 'Pending' },
  { id: 3, name: 'Charlie Brown', email: 'charlie@example.com', documentUrl: 'https://example.com/doc3.pdf', status: 'Pending' },
];

const VerificationRequests: React.FC = () => {
  const [requests, setRequests] = useState(initialRequests);
  const [popup, setPopup] = useState<{ type: 'accept' | 'reject'; request: VerificationRequest } | null>(null);

  const handleConfirm = () => {
    if (popup) {
      setRequests(requests.map(request => 
        request.id === popup.request.id ? { ...request, status: popup.type === 'accept' ? 'Accepted' : 'Rejected' } : request
      ));
      setPopup(null);
    }
  };

  return (
    <div className="">
      <h2 className="text-2xl font-bold text-teal-700 mb-4">📜 Verification Requests</h2>
      <div className="bg-white shadow-lg rounded-lg overflow-hidden">
        <table className="min-w-full">
          <thead className="bg-teal-600 text-white">
            <tr>
              <th className="p-3 text-left">Name</th>
              <th className="p-3 text-left">Email</th>
              <th className="p-3 text-left">Status</th>
              <th className="p-3 text-right">Actions</th>
            </tr>
          </thead>
          <tbody>
            {requests.map((request) => (
              <tr key={request.id} className="border-b hover:bg-teal-100 transition">
                <td className="p-3">{request.name}</td>
                <td className="p-3">{request.email}</td>
                <td className={`p-3 font-semibold ${request.status === 'Accepted' ? 'text-green-600' : request.status === 'Rejected' ? 'text-red-600' : 'text-yellow-600'}`}>
                  {request.status}
                </td>
                <td className="p-3 text-right">
                  <a href={request.documentUrl} target="_blank" rel="noopener noreferrer" className="text-teal-500 hover:text-teal-700 mr-3">
                    <FaEye />
                  </a>
                  <button className="text-teal-600 hover:text-teal-800 mr-3" onClick={() => setPopup({ type: 'accept', request })}>
                    <FaCheckCircle />
                  </button>
                  <button className="text-red-500 hover:text-red-700" onClick={() => setPopup({ type: 'reject', request })}>
                    <FaTimesCircle />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Confirmation Popup */}
      {popup && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white p-6 rounded-lg shadow-lg text-center">
            <h3 className="text-lg font-semibold text-teal-700 mb-2">
              {popup.type === 'accept' ? 'Confirm Accept' : 'Confirm Reject'}
            </h3>
            <p className="text-gray-600">Are you sure you want to {popup.type} this verification request?</p>
            <div className="flex justify-center mt-4">
              <button 
                className="bg-teal-600 hover:bg-teal-700 text-white px-4 py-2 rounded mr-2 transition"
                onClick={handleConfirm}
              >
                Confirm
              </button>
              <button 
                className="bg-gray-300 hover:bg-gray-400 text-gray-800 px-4 py-2 rounded transition"
                onClick={() => setPopup(null)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default VerificationRequests;
